import { socialApi } from "core/api";
import { Dispatch } from "../../store.types";
import * as actions from "./social.actions";

export const getIGProfiles = () => async (dispatch: Dispatch) => {
  dispatch(actions.isProfilesLoading({ isProfilesLoading: true }));
  try {
    const profiles = await socialApi.getProfiles();
    dispatch(actions.profileList({ profileList: profiles }));
  } catch (err) {
    console.log(err);
  } finally {
    dispatch(actions.isProfilesLoading({ isProfilesLoading: false }));
  }
};

export const getPostList =
  (instagramId: string, page: number) => async (dispatch: Dispatch) => {
    dispatch(actions.isPostLoading({ isPostLoading: true }));
    try {
      const posts = await socialApi.getPosts(instagramId, page);

      dispatch(actions.postList({ postList: posts }));
    } catch (err) {
      console.log(err);
      dispatch(actions.postError({ error: "Last page!" }));
    } finally {
      dispatch(actions.isPostLoading({ isPostLoading: false }));
    }
  };

export const calculatePricing =
  (instagramId: string, posts: string[]) => async (dispatch: Dispatch) => {
    dispatch(actions.isPricingLoading({ isPricingLoading: true }));
    try {
      const pricingObject = await socialApi.getPricing(instagramId, posts);
      dispatch(actions.pricingObject({ pricingObject }));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(actions.isPricingLoading({ isPricingLoading: false }));
    }
  };

export const requestReport =
  (
    posts: string[],
    pricingRequestId: string,
    igPageId: string,
    level: number
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(actions.isPricingLoading({ isPricingLoading: true }));
    try {
      const body = {
        posts: posts,
        ig_page_id: igPageId,
        pricing_request_id: pricingRequestId,
        level: level,
      };
      const message = await socialApi.sendRequest(body);
      dispatch(actions.reportSuccess({ success: message }));
    } catch (err) {
      console.log(err);
      dispatch(actions.reportError({ error: "NOT OK" }));
    } finally {
      dispatch(actions.isPricingLoading({ isPricingLoading: false }));
    }
  };

export const getReportDetail =
  (fileId: number) => async (dispatch: Dispatch) => {
    dispatch(actions.resetSocial());
    dispatch(actions.isSocialReportLoading({ isSocialReportLoading: true }));
    try {
      const reportDetail = await socialApi.getReportDetail(fileId);
      // const reportDetail = transformSocialReportDetail(JSONMocked);
      dispatch(actions.reportDetail({ detail: reportDetail }));
      dispatch(actions.isReportReady({ isReportReady: true }));
    } catch (err) {
      console.log(err);
      dispatch(actions.reportError({ error: "NOT OK" }));
      dispatch(actions.isReportReady({ isReportReady: false }));
    } finally {
      dispatch(actions.isSocialReportLoading({ isSocialReportLoading: false }));
    }
  };
